'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import { Button, Center, Heading, VStack, Text, HStack, Separator } from '@chakra-ui/react';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import Image from 'next/image';
import { LOGIN_RETURN_PARAM, safeLoginReturnPath } from '@/utils/auth/loginReturnPath';
import { createClient } from '@/utils/supabase/client';
const supabase = createClient();

// Where to go once signed in: the OAuth consent page when it sent the
// visitor here, `/` otherwise.
const returnPath = typeof window === 'undefined' ? undefined : safeLoginReturnPath(new URLSearchParams(window.location.search).get(LOGIN_RETURN_PARAM), window.location.origin);

// Return to whichever origin the user signed in from (production, or a
// Vercel preview URL) instead of falling back to Supabase's configured
// Site URL. The origin must also be allow-listed in Supabase Auth →
// Redirect URLs, otherwise Supabase ignores this and uses the Site URL.
// With a return path, Google sends the visitor back to this page, which
// finishes the sign-in and then follows it.
const redirectTo = typeof window === 'undefined' ? undefined : returnPath ? `${window.location.origin}/login?${new URLSearchParams({
  [LOGIN_RETURN_PARAM]: returnPath
}).toString()}` : `${window.location.origin}/`;

// Note: The Supabase Auth UI that this page uses is no longer maintained.
// If we encounter issues with it, we may want to implement our own UI.
// Supabase has guides on how to do it.
const Login = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  const handleSignOut = _temp3;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Center h="100vh">{process.env.NEXT_PUBLIC_EMAIL_PW_AUTH_IS_ENABLED === "true" ? <VStack gap={3}><Auth appearance={{
          style: {
            container: {
              width: 300
            }
          },
          theme: ThemeSupa
        }} providers={["google"]} queryParams={{
          prompt: "select_account"
        }} redirectTo={redirectTo} supabaseClient={supabase} /><SignedInWithWrongAccount onSignOut={handleSignOut} /></VStack> : <VStack borderRadius={5} borderWidth={1} boxShadow="xl" height="50vh" justifyContent="space-around" padding={7}><HStack><Text textStyle="lg">Ancestralize</Text><Image alt="company-logo" height={20} src="/company-logo.jpeg" width={20} /></HStack><Heading as="h3" color="gray.700">Knowledge Base Editor</Heading><Image alt="kbe-logo" height={50} src="/icon.svg" width={50} /><Heading as="h4" size="md">Please sign-in with Google to continue</Heading><Separator borderColor="gray.700" /><Auth appearance={{
          style: {
            container: {
              width: 300
            }
          },
          theme: ThemeSupa
        }} onlyThirdPartyProviders={true} providers={["google"]} queryParams={{
          prompt: "select_account"
        }} redirectTo={redirectTo} supabaseClient={supabase} /><SignedInWithWrongAccount onSignOut={handleSignOut} /></VStack>}</Center>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const SignedInWithWrongAccount = t0 => {
  const $ = _c(3);
  const {
    onSignOut
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text color="gray.500" fontSize="xs">Signed in with the wrong account?</Text>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSignOut) {
    t2 = <VStack gap={1}>{t1}<Button size="xs" variant="ghost" onClick={onSignOut}>Sign out</Button></VStack>;
    $[1] = onSignOut;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Login;
function _temp(event) {
  if (event === "SIGNED_IN") {
    window.location.href = returnPath ?? "/";
  }
}
function _temp2() {
  const {
    data
  } = supabase.auth.onAuthStateChange(_temp);
  return () => {
    data.subscription.unsubscribe();
  };
}
async function _temp3() {
  await supabase.auth.signOut({
    scope: "local"
  });
}